// ROW 1 — SHAPE (morphs in for shapes, paths, groups and multi-selections).
// R2 made the R0 placeholder HONEST: everything fill-adjacent lives on Row 2
// (universal), so Row 1 carries only what is truly shape-scoped TODAY:
//   · the type/count readout (a shape's Row 1 has little to say yet — R5
//     brings universal styling depth to shapes);
//   · corner radius — the ONE cheap shape verb that exists
//     (editor.changeCornerRadius, Rect-only → showWhen shapeIsRect);
//   · Ungroup — the group branch's orphan from the toolbar retirement
//     (showWhen canUngroup; Group's inverse lives in Row 2's Arrange "…");
//   · Edit-smart-object — the recipe strip's orphan (showWhen
//     smartRecipeName; smart objects are Groups today);
//   · flips (no Row-2 home by design — mirroring is object-kind work).
// The R0 'sides' stepper is GONE: no engine verb exists (the sides slider in
// the drawer is the 3D extrude dress, a different thing) and a dead control
// would be a lie.

const shapeRow1 = {
  id: 'shape-row1',
  row: 1,
  groups: [
    {
      // Owner directive §3 (2026-07-21): swap the SILHOUETTE while keeping
      // every style customization. The leading button opens the ObjectSwapModal
      // (shape grid); the pick fires shape.openSwap → editor.swapShapeType,
      // which fits the new outline to the current box and carries fill/stroke/
      // effects/data. showWhen 'canSwapShape' (the mount): only a single
      // swappable primitive shows it — a group / smart object / multi-selection
      // has no ONE silhouette to swap, so a control there would be a lie.
      id: 'shapeChange',
      label: 'Change',
      drawerSection: null,
      showWhen: 'canSwapShape',
      neverCollapse: true,
      controls: [
        { id: 'changeShape', kind: 'button', label: 'Change shape — pick a new outline, keep the styling', icon: 'shapes', text: 'Change shape', handler: 'shape.openSwap' },
      ],
    },
    {
      id: 'shapeInfo',
      label: 'Selection',
      drawerSection: null,
      neverCollapse: true,
      controls: [
        // 'Rectangle' / 'Circle' / 'Group' / '3 selected' (mount-derived).
        { id: 'shapeTypeLabel', kind: 'badge', label: 'What is selected', read: 'shapeTypeLabel' },
      ],
    },
    {
      id: 'shapeGeom',
      label: 'Corners',
      // Owner directive §2 (2026-07-21): the number box + its "…" corner are
      // GONE — an INLINE slider on the row (the pageRow1 Sun grammar). A slider
      // is NOT a flyout kind, so a declared drawerSection would re-raise the
      // corner "…" the owner called out; null keeps the row clean (the drawer's
      // corner fine-tune has no dedicated surface anyway — the slider IS it).
      drawerSection: null,
      showWhen: 'shapeIsRect',
      collapsePriority: 2,
      controls: [
        // Wiring: editor.changeCornerRadius (rx/ry, Rect only — the group
        // renders only when the selection can honor it). Live-drag preview,
        // ONE undo entry on release: defer ticks + history.commitNow (the
        // house slider commit posture — see the mount's shape.setCornerRadius).
        { id: 'cornerRadius', kind: 'slider', label: 'Corners', read: 'cornerRadius', min: 0, max: 400, step: 2, handler: 'shape.setCornerRadius', commit: 'defer', fallback: 0, format: (v) => `Corners ${Math.round(Number.isFinite(v) ? v : 0)}` },
      ],
    },
    {
      // Depth-Everywhere wave N (lane N2): the Corners power un-gated past Rect.
      // A non-Rect shape (triangle/polygon/path) has no live rx/ry — rounding
      // is a DESTRUCTIVE bake to a plain fabric.Path (exportability law). So
      // this is its OWN group, gated shapeCanBakeCorners (single cornered fill
      // shape; circle/ellipse have no corners, so they show no slider — a
      // control that can't act is a lie). Honest 'bake on release' UX: no live
      // tick (a cheap live preview isn't feasible — every tick would re-run the
      // WASM offset + replace the object), the slider commits ONCE when you let
      // go (shape.bakeCorners stashes the value; the mount's history.commitNow
      // flushes the bake — ONE undo entry). The Rect group above is UNTOUCHED
      // (its rx/ry stays live/non-destructive — zero regression).
      id: 'shapeGeomBake',
      label: 'Round corners',
      drawerSection: null,
      showWhen: 'shapeCanBakeCorners',
      collapsePriority: 2,
      controls: [
        { id: 'roundCorners', kind: 'slider', label: 'Round corners — rounds when you let go', read: 'cornerBakeRadius', min: 0, max: 400, step: 2, handler: 'shape.bakeCorners', commit: 'defer', fallback: 0, format: (v) => (Number(v) > 0 ? `Round corners ${Math.round(v)}` : 'Round corners') },
      ],
    },
    {
      id: 'shapeUngroup',
      label: 'Group',
      drawerSection: null,
      showWhen: 'canUngroup',
      collapsePriority: 3,
      controls: [
        // Wiring: editor.ungroup (Group → ActiveSelection of its children).
        { id: 'ungroupBtn', kind: 'button', label: 'Ungroup', icon: 'ungroup', text: 'Ungroup', handler: 'arrange.ungroup' },
      ],
    },
    {
      id: 'smartEdit',
      label: 'Smart object',
      drawerSection: null,
      showWhen: 'smartRecipeName',
      neverCollapse: true,
      controls: [
        // Wiring: the Smart Objects panel (parametric recipe editor). The
        // button text names the recipe via the smartEditLabel mirror.
        { id: 'smartEditOpen', kind: 'button', label: 'Edit this smart object’s settings', icon: 'effects', textFrom: 'smartEditLabel', text: 'Edit…', handler: 'ui.openSmartPanel' },
      ],
    },
    {
      id: 'shapeFlip',
      label: 'Flip',
      drawerSection: null,
      collapsePriority: 1,
      controls: [
        { id: 'shapeFlipH', kind: 'button', label: 'Flip horizontal', icon: 'flipH', handler: 'object.flipH' },
        { id: 'shapeFlipV', kind: 'button', label: 'Flip vertical', icon: 'flipV', handler: 'object.flipV' },
      ],
    },
  ],
};

export default shapeRow1;
